let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bpm8H")).then(() => parcelRequire('gqdUN'));